export const isNotNull = (x) => x !== null;
//# sourceMappingURL=is-not-null.js.map